export default __webpack_public_path__ + "static/media/back.12014757.svg";